import React from "react";
import { Platform, Pressable, Text, View } from "react-native";

import { MOTION, WAVE_EASINGS, WAVE_TUNABLES } from "../board/motionConfig";
import { useWaveTuning } from "../board/waveTuning";
import { Btn, Row } from "./controls";
import { devStyles as s } from "./devStyles";

type Tunable = (typeof WAVE_TUNABLES)[number];

const round = (v: number, step: number) =>
  Number((Math.round(v / step) * step).toFixed(step < 1 ? 2 : 0));

function Slider({
  t,
  onChange,
}: {
  t: Tunable;
  onChange: (v: number) => void;
}) {
  const value = MOTION[t.key] as number;
  if (Platform.OS === "web") {
    return React.createElement("input", {
      type: "range",
      min: t.min,
      max: t.max,
      step: t.step,
      value,
      "aria-label": t.label,
      style: { width: 110 },
      onChange: (e: { target: { value: string } }) =>
        onChange(Number(e.target.value)),
    });
  }
  const nudge = (d: number) =>
    onChange(
      round(Math.max(t.min, Math.min(t.max, value + d * t.step)), t.step),
    );
  return (
    <View style={s.row}>
      <Pressable onPress={() => nudge(-1)} style={s.btn}>
        <Text style={s.text}>−</Text>
      </Pressable>
      <Pressable onPress={() => nudge(1)} style={s.btn}>
        <Text style={s.text}>+</Text>
      </Pressable>
    </View>
  );
}

/** #119's wave tuning: a slider per wave value, easing, replays, reset. */
const WaveSection: React.FC = () => {
  const tuning = useWaveTuning();
  return (
    <View testID="wave-tuning-panel">
      {WAVE_TUNABLES.map((t) => (
        <View key={t.key} style={s.row}>
          <Text style={[s.text, s.label]}>{t.label}</Text>
          <Text style={[s.text, s.value]}>{String(MOTION[t.key])}</Text>
          <Slider t={t} onChange={(v) => tuning.set(t.key, v)} />
        </View>
      ))}
      <Row wrap>
        {WAVE_EASINGS.map((e) => (
          <Btn
            key={e}
            label={e}
            on={MOTION.waveEasing === e}
            onPress={() => tuning.set("waveEasing", e)}
          />
        ))}
      </Row>
      <Row wrap>
        <Btn
          label="Replay streak wave"
          onPress={() => tuning.requestReplay("streak")}
        />
        <Btn
          label="Replay win wave"
          onPress={() => tuning.requestReplay("win")}
        />
        <Btn label="Reset" onPress={tuning.reset} />
      </Row>
    </View>
  );
};

export default WaveSection;
